import themes from "../themes.js";
let haveListener = false;
const getActiveTheme = (htmlEl, attr) => {
  var _a;
  let activeTheme = null;
  for (let i = 0; i < themes.length; i++) {
    const theme = themes[i];
    if (theme === "system") return;
    if ((_a = htmlEl.getAttribute(attr)) == null ? void 0 : _a.includes(themes[i])) {
      activeTheme = themes[i];
      break;
    }
  }
  return activeTheme;
};
const set = (self, theme) => {
  if (!self.HTMLElement) return;
  if (themes.includes(theme)) {
    self.HTMLElement.dataset.calendarTheme = theme;
    return;
  }
  console.error("Incorrect name of theme in settings.visibility.theme");
};
const get = (self, supportDarkTheme) => {
  if (!supportDarkTheme) {
    set(self, "light");
    return;
  }
  const theme = (e) => e.matches ? "dark" : "light";
  self.HTMLElement.dataset.calendarTheme = theme(supportDarkTheme);
  if (!haveListener) {
    supportDarkTheme.onchange = (e) => {
      if (self.settings.visibility.theme !== "system") return;
      self.HTMLElement.dataset.calendarTheme = theme(e);
    };
    haveListener = true;
  }
};
const track = (self, htmlEl, attr) => {
  const changes = (mutationsList) => {
    for (let i = 0; i < mutationsList.length; i++) {
      const record = mutationsList[i];
      if (record.attributeName === attr) {
        const activeTheme = getActiveTheme(htmlEl, attr);
        if (activeTheme) set(self, activeTheme);
        break;
      }
    }
  };
  const observer = new MutationObserver(changes);
  observer.observe(htmlEl, {
    attributes: true
  });
};
const detect = (self, supportDarkTheme) => {
  if (!self.HTMLElement) return;
  const detectedThemeEl = self.settings.visibility.themeDetect ? document.querySelector(self.settings.visibility.themeDetect) : false;
  if (!detectedThemeEl) {
    get(self, supportDarkTheme);
    return;
  }
  const attr = self.settings.visibility.themeDetect.replace(/^.*\[(.+)\]/g, (_, p1) => p1);
  const strValues = detectedThemeEl.hasAttribute(attr);
  if (!attr || !strValues) {
    get(self, supportDarkTheme);
    return;
  }
  const activeTheme = getActiveTheme(detectedThemeEl, attr);
  if (activeTheme) {
    set(self, activeTheme);
    track(self, detectedThemeEl, attr);
  } else {
    get(self, supportDarkTheme);
  }
};
const setTheme = (self) => {
  if (!self.HTMLElement) return;
  let supportDarkTheme;
  if (window.matchMedia("(prefers-color-scheme)").media !== "not all") {
    supportDarkTheme = window.matchMedia("(prefers-color-scheme: dark)");
  }
  if (self.settings.visibility.theme === "system") {
    detect(self, supportDarkTheme);
  } else {
    set(self, self.settings.visibility.theme);
  }
};
export {
  setTheme as default
};
